import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./style.css";
import { Button, Modal } from "react-bootstrap";
import localization from "assets/localization/localization";
import Loader from "components/sales/Loader/loader";
import Images from 'assets/images/imageData';

const ErrModalPop = ({
  title = "title",
  children,
  show,
  footer = false,
  handleModalHide,
  keyboard = false,
  backdrop = false,
  footerCloseBtn = false,
  handleModalSubmit,
  footerSubmitTxt = null,
  isLoading = false,
}) => {
  return (
    <Fragment>
      <Modal
      show={show}
      onHide={handleModalHide}
      keyboard={keyboard ? false : true}
      backdrop={backdrop ? "static" : true}
    >
      
      <Modal.Header closeButton>
        <Modal.Title><img src={Images?.alert} alt="" width="25px" />{title}</Modal.Title>
        
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footer ? (
        <Modal.Footer>
          {footerCloseBtn ? (
            <Button onClick={handleModalHide}>{localization.close}</Button>
          ) : null}
          <Button onClick={handleModalSubmit}>
            {footerSubmitTxt || localization.saveChanges}
          </Button>
        </Modal.Footer>
      ) : null}
    </Modal>
      <Loader isLoading={isLoading} />
    </Fragment>
    
  );
};

ErrModalPop.propTypes = {
  show: PropTypes.bool,
};

export default ErrModalPop;
